module.exports = __webpack_public_path__ + "2f629dc181ed14ec644fe8dfd97ca55e.png";